import {Injectable} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import { DialogComponent } from '../../../shared/dialog/dialog/dialog.component';
import { ConfirmationDialogComponent } from '../../../shared/dialog/confirmation-dialog/confirmation-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public dialog: MatDialog) {
  }

  openDialog(title: string, message: string): void {
    this.dialog.open(DialogComponent, {
      data: {title, message}, // Pasamos los datos al componente de diálogo
    });
  }

  openErrorDialog(title: string, message: string): void {
    this.dialog.open(DialogComponent, {
      data: {title, message}, // Pasamos los datos al componente de diálogo
    });
  }

  openSuccesDialog(title: string, message: string): void {
    this.dialog.open(DialogComponent, {
      data: {title, message}, // Pasamos los datos al componente de diálogo
    });
  }

  openConfirmationDialog(title: string, message: string, onClose: Function): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {title, message}, // Pasamos los datos al componente de diálogo
    });
    dialogRef.afterClosed().subscribe(value => {
      onClose(value)
    })
  }

  openCustomDialog(customDialog: any, onClose: Function): void {
    const dialogRef = this.dialog.open(customDialog);
    dialogRef.afterClosed().subscribe(value => {
      onClose(value)
    })
  }
}
